/* General Settings for the views */

const settings = {
    apiExperimentCSVPageSize: 8000,
    apiFilesCSVPageSize: 2000,
    basicPageSize: 100
} 


export default settings;